import { isMobile } from 'shared/responsive-helpers'

import { withRouter } from 'i18n/utils'

import IconButton from '@components/IconButton'
import { ButtonSwitch } from '@components/ButtonSwitch'
import { CardSection } from '@components/CardSection'
import { getSwitchButtons } from '@booking/utils'
import { SEARCH_MODE_EVENTS, SEARCH_MODE_MONTHLY, SEARCH_MODE_PREPAID } from 'search/constants'
import { locationDetailsPendingSelector } from '@booking/selectors'
import { clearSelectedRate, getBookingLocationDetails, setParkingMode } from '@booking/actions'
import featureToggles from 'shared/featureToggles'

const BookingViewHeader = ({
    defaultCustomerFlow,
    parkingMode,
    detailsPending,
    clearSelectedRate,
    setParkingMode,
    grsId,
    name,
    history: { push },
}) => {
    const isEventFlow = parkingMode === SEARCH_MODE_EVENTS && featureToggles.hasEventFlow

    const onClickSwitchTo = searchMode => {
        clearSelectedRate()
        setParkingMode(searchMode)

        switch (searchMode) {
            case SEARCH_MODE_MONTHLY:
                push(`/booking/${grsId}/subscriptions`)
                break
            case SEARCH_MODE_EVENTS:
                push(`/booking/${grsId}/events`)
                break
            case SEARCH_MODE_PREPAID:
            default:
                push(`/booking/${grsId}`)
                break
        }
    }

    const switchButtons = React.useMemo(() => getSwitchButtons(defaultCustomerFlow, parkingMode, onClickSwitchTo), [
        defaultCustomerFlow,
        parkingMode,
    ])

    return (
        <CardSection loading={detailsPending && !(detailsPending instanceof Error)}>
            <div className="d-flex align-items-center booking__main__address">
                <span className="booking__main__address__icon pin" />
                <p className="booking__main__address__text">{name}</p>
                {!isMobile() && (
                    <IconButton
                        href={isEventFlow ? '/' : '/map'}
                        icon={isEventFlow ? 'search' : 'map'}
                        label={isEventFlow ? <T>booking.change.carpark</T> : <T>booking.back.to.map</T>}
                    />
                )}
            </div>
            {parkingMode && defaultCustomerFlow && switchButtons.length > 1 && (
                <ButtonSwitch
                    className="mt-2"
                    btnStyle="bookingView"
                    label={<T>booking.switch.label</T>}
                    buttons={switchButtons}
                />
            )}
        </CardSection>
    )
}

export default compose(
    withRouter,
    connect(
        createStructuredSelector({
            detailsPending: locationDetailsPendingSelector,
        }),
        {
            getBookingLocationDetails,
            clearSelectedRate,
            setParkingMode,
        }
    )
)(BookingViewHeader)
